/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CardApplicationProfileSaveCommand } from './CardApplicationProfileSaveCommand';
import type { SaveAddressCommand } from './SaveAddressCommand';
export type CreateCardApplicationCommand = {
    /**
     * Card application unique number.
     */
    applicationNumber?: string;
    /**
     * Contact a customer when his card was found. Default: true
     */
    contactMeIfCardFound: boolean;
    /**
     * Identifier that card application was created from eshop. Default: false
     */
    eshop?: boolean;
    note?: string;
    /**
     * Delivery branch office identifier. Type: 'UUID'
     */
    deliveryBranchOfficeId?: string;
    recipientAddress?: SaveAddressCommand;
    /**
     * Whenever should photo be saved for 36 months.
     */
    keepPhoto: boolean;
    /**
     * Customer email for eshop to pair card application and account.
     */
    username?: string;
    /**
     * Identifier that card application is for free. Default: false
     */
    cardForFree?: boolean;
    /**
     * Card type
     */
    cardType: CreateCardApplicationCommand.cardType;
    /**
     * Filter data by tenant FTP username
     */
    tenantFTPName?: string;
    /**
     * Client current timezone offset in minutes. Is required.
     */
    timezoneOffset?: number;
    profileOne: CardApplicationProfileSaveCommand;
    profileTwo?: CardApplicationProfileSaveCommand;
    /**
     * Agree with marketing consent. Default: false
     */
    marketingConsent?: boolean;
    /**
     * Customer identifier. Type: 'UUID'
     */
    customerId: string;
};
export namespace CreateCardApplicationCommand {
    /**
     * Card type
     */
    export enum cardType {
        SMART_CARD = 'SMART_CARD',
        SMART_CARD_2 = 'SMART_CARD_2',
        SMART_CARD_WITHOUT_STRUCTURE = 'SMART_CARD_WITHOUT_STRUCTURE',
        BANK_CARD = 'BANK_CARD',
        MOBILE_PHONE = 'MOBILE_PHONE',
        WHITE_LIST_CARD = 'WHITE_LIST_CARD',
        EXTERNAL_CARD = 'EXTERNAL_CARD',
        QR_CODE_CARD = 'QR_CODE_CARD',
        PAPER_CARD = 'PAPER_CARD',
    }
}

